import { auditActionTypes as actionType } from 'src/constants/actionTypes';
import auditService from 'src/services/auditService';
import dispatchError from 'src/utils/dispatchError';

export function getAuditFields() {
  return async (dispatch) => {
    try {
      const fields = await auditService.getAuditFields();
      dispatch({
        type: actionType.GET_FIELDS_SUCCESS,
        payload: { fields }
      });
    } catch (error) {
      dispatchError(dispatch, error, actionType.FAILURE, 'Failed to load audit fields');
    }
  };
}

export function searchAudit(data) {
  return async (dispatch) => {
    try {
      const list = await auditService.searchAudit(data);
      dispatch({
        type: actionType.SEARCH_SUCCESS,
        payload: { list }
      });
    } catch (error) {
      dispatchError(dispatch, error, actionType.FAILURE, 'Failed to search audit log');
    }
  };
}

export function exportAudit(data) {
  return async (dispatch) => {
    try {
      const response = await auditService.exportAudit(data);
      const file = new Blob(
        [response.blob],
        { type: 'application/octet-stream' }
      );

      const fileURL = URL.createObjectURL(file);
      const filename = 'audit.csv';

      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display:none';
      a.href = fileURL;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(fileURL);
      a.remove();
      dispatch({ type: actionType.EXPORT_SUCCESS });
    } catch (error) {
      dispatchError(dispatch, error, actionType.FAILURE, 'Failed to export audit log');
    }
  };
}

export function saveAuditSearch(data) {
  return async (dispatch) => {
    try {
      const savedAuditSearchRes = await auditService.saveAuditSearch(data);
      const payload = {
        ...savedAuditSearchRes,
        query: data.query || []
      };

      dispatch({
        type: actionType.SAVE_SUCCESS,
        payload: {
          savedAuditSearch: payload,
          successMsg: 'Your search was saved'
        }
      });
    } catch (error) {
      dispatchError(dispatch, error, actionType.FAILURE, 'Failed to save the search');
    }
  };
}

export function getSavedAuditSearches(data) {
  return async (dispatch) => {
    try {
      const savedAuditSearchList = await auditService.getSavedAuditSearches(data);

      dispatch({
        type: actionType.GET_ALL_SUCCESS,
        payload: {
          savedAuditSearchList
        }
      });
    } catch (error) {
      dispatchError(dispatch, error, actionType.FAILURE, 'Failed to get saved searches');
    }
  };
}

export function deleteSavedAuditSearch(searchId) {
  return async (dispatch) => {
    try {
      const savedAuditSearchList = await auditService.deleteSavedAuditSearch(searchId);

      dispatch({
        type: actionType.DELETE_SUCCESS,
        payload: {
          id: savedAuditSearchList.id
        }
      });
    } catch (error) {
      dispatchError(dispatch, error, actionType.FAILURE, 'Failed to delete saved search');
    }
  };
}

export const removeMessageAudit = () => ({ type: actionType.CLEAR_MESSAGES });
export const clearSearch = () => ({ type: actionType.SEARCH_CLEAR });
export const setStatus = (status) => ({
  type: actionType.SET_STATUS,
  payload: { status }
});
